module.exports = __webpack_public_path__ + "static/media/kredyt_4.b26c227d.png";